import { TopNavigationLeftAction, UIMessagingState } from './types';

import { NSRootActionTree } from '~/store/types';

export default {
  startCustomBackAction(context) {
    context.commit('START_CUSTOM_BACK_ACTION');
  },
  finishCustomBackAction(context) {
    context.commit('FINISH_CUSTOM_BACK_ACTION');
  },
  setMenuTopNavigationLeftAction(context) {
    context.commit(
      'SET_TOP_NAVIGATION_LEFT_ACTION',
      TopNavigationLeftAction.Menu
    );
  },
  setBackTopNavigationLeftAction(context) {
    context.commit(
      'SET_TOP_NAVIGATION_LEFT_ACTION',
      TopNavigationLeftAction.Back
    );
  },
} as NSRootActionTree<UIMessagingState>;
